import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(isSameOrBefore);

type DobRule = {
  message: string;
  validator: (rule: unknown, value?: string) => Promise<true | undefined>;
};

const LABEL_INVESTOR = "Investor";
const LABEL_INVALID_DOB_ERROR = "[TARGET] has to be at least 18 years old";
const TARGET_PLACEHOLDER = "[TARGET]";
const MINIMUM_AGE_YEARS = 18;

const validateDob = (target = LABEL_INVESTOR): DobRule => {
  const message = LABEL_INVALID_DOB_ERROR.replace(TARGET_PLACEHOLDER, target);

  const validator = async (_: unknown, value?: string): Promise<true | undefined> => {
    if (!value) {
      return true;
    }

    const maxDateOfBirth = dayjs().subtract(MINIMUM_AGE_YEARS, "year");

    const isValid = dayjs(value).isSameOrBefore(maxDateOfBirth);

    if (!isValid) {
      throw new Error(message);
    }

    return undefined;
  };

  return {
    message,
    validator,
  };
};

export default validateDob;
